import React from "react";

const DetailHTML = ({ htmlString }) => {
  return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
};

export default DetailHTML;
